(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
    .directive('contributorEntry', ['$timeout', '$translate', 'SourceConstant', 'DocumentStateService', 'AppConstants',
        function ($timeout, $translate, SourceConstant, DocumentStateService, AppConstants) {
            return {
                restrict: 'E',
                scope: {
                    person: '=',
                    role: '=type'
                },
                link: function (scope, element, attrs) {

                    // AppConstant bindings
                    var globalRoles = AppConstants.GlobalRoles,
                        collaboratorTypes = AppConstants.CollaboratorTypes;

                    scope.isUser = scope.person.Type === collaboratorTypes.USER;
                    scope.isGroup = scope.person.Type === collaboratorTypes.GROUP;
                    scope.isAnon = scope.person.Type === collaboratorTypes.ANONYMOUS;

                    scope.didSelectPerson = scope.$parent.switchTab;
                    scope.isGroupSelected = scope.$parent.isGroupSelected;

                    // if there is no comma in that string, it will return a array only having one element.
                    scope.multipleRoles = scope.role.split(',');

                    scope.roleToHumanString = function (role) {
                        switch (role) {
                            case globalRoles.VIEWER:
                                return $translate.instant('RIGHT_NAV.VIEWER');
                            case globalRoles.CONTRIBUTOR:
                                return $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                            case globalRoles.COOWNER:
                                return $translate.instant('RIGHT_NAV.CO_OWNER');
                            default:
                                return $translate.instant('RIGHT_NAV.OWNER');
                        }
                    };

                    scope.isOwner = function (role) {
                        return role === globalRoles.OWNER;
                    };

                },
                templateUrl: './shared/contributor_entry.html'
            };
        }
    ]);
}());
